'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { getAssetUrl } from 'lib/config/assetUrls';
import {
  IvBodyText,
  IvContentShell,
  IvSectionRoot,
} from './ivLoungeSectionLayout';
import { IV_LOUNGE_REVIV_LOGO } from './ivLoungePageAssets';
import styles from './IvLoungeRevivSection.module.css';

export const IvLoungeRevivSection: React.FC = () => {
  const t = useTranslations('performance-lab');

  const stats = [
    {
      value: t('ivLounge.reviv.stats.0.value'),
      label: t('ivLounge.reviv.stats.0.label'),
    },
    {
      value: t('ivLounge.reviv.stats.2.value'),
      label: t('ivLounge.reviv.stats.2.label'),
    },
    {
      value: t('ivLounge.reviv.stats.3.value'),
      label: t('ivLounge.reviv.stats.3.label'),
    },
  ];

  return (
    <IvSectionRoot aria-label={t('ivLounge.reviv.aria')}>
      <IvContentShell className={styles.shell}>
        <div className={styles.block}>
          <img
            className={styles.revivWordmark}
            src={getAssetUrl(`/${IV_LOUNGE_REVIV_LOGO}`)}
            alt={t('ivLounge.reviv.heading')}
          />
          <div className={styles.paragraphs}>
            <IvBodyText>
              {t('ivLounge.reviv.body1')}
            </IvBodyText>
            <IvBodyText>
              {t('ivLounge.reviv.body2')}
            </IvBodyText>
          </div>
        </div>

        <dl className={styles.statsRow} aria-label={t('ivLounge.reviv.statsAria')}>
          {stats.map((stat) => (
            <div className={styles.statGroup} key={stat.label}>
              <dt className={styles.statValue}>{stat.value}</dt>
              <dd className={styles.statLabel}>{stat.label}</dd>
            </div>
          ))}
        </dl>
      </IvContentShell>
    </IvSectionRoot>
  );
};
